import qs from 'qs'
import request, { ResultHandler } from '@/core/utils/request'
const AddressBaseUrl = '/business/address'

export const queryAddress = async params => {
  const result = await request({
    url: AddressBaseUrl,
    method: 'GET',
    params: params,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
  return ResultHandler(result, 'Search address failed!')?.page ?? []
}

export const saveAddress = async data => {
  const result = await request({
    url: AddressBaseUrl,
    method: 'POST',
    data
  })
  return ResultHandler(result, 'Save address failed!')
}

export const deleteAddress = async addressId => {
  const result = await request({
    url: `${AddressBaseUrl}/${addressId}`,
    method: 'DELETE'
  })
  return ResultHandler(result, 'Delete address failed!')
}

export const queryAddressGeo = async params => {
  const result = await request({
    url: AddressBaseUrl + '/geo',
    method: 'GET',
    params,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
  return ResultHandler(result, 'Get geo location failed!')?.geo ?? null
}
